export const Currencies = {
  EUR: 'EUR',
  LTC: 'LTC',
  SOL: 'SOL',
  UAH: 'UAH',
  USD: 'USD',
  USDT: 'USDT'
};

export const currencyOptions = [
  { label: 'UAH', value: 'UAH' },
  { label: 'USD', value: 'USD' },
  { label: 'EUR', value: 'EUR' },
  { label: 'SOL', value: 'SOL' },
  { label: 'LTC', value: 'LTC' },
  { label: 'USDT', value: 'USDT' }
];

export const cryptoCurrencyList = ['LTC', 'SOL', 'USDT'];

export const isCryptoCurrency = (currency) =>
  cryptoCurrencyList.includes(currency);
